const internalEndpoint = String(
  process.env.VUE_APP_ANALYTICS_ENDPOINT || 'https://sitebypro-server.ru/druzbamebel/analytics/collect'
).trim().replace('/druzhbamebel/', '/druzbamebel/')

export const ANALYTICS_CONFIG = Object.freeze({
  metricaCounterId: Number(process.env.VUE_APP_YANDEX_METRIKA_ID || 0),
  metricaDebug: String(process.env.VUE_APP_YANDEX_METRIKA_DEBUG || '').toLowerCase() === 'true',
  internalEndpoint,
  internalEnabled: String(process.env.VUE_APP_INTERNAL_ANALYTICS_ENABLED || 'true').toLowerCase() !== 'false',
  ecommerceContainer: 'dataLayer',
  currency: 'RUB'
})
